const DashboardItemCardStyles = {
  DashboardItemCardContainer: {
    width: "200px",
    minHeight: "200px",
    border: "1px solid grey",
    borderRadius: 2,
  },
  // Extracted styles from JSX
  StyledCard: {
    width: "100%", // Fill the grid cell
    minHeight: 160,
    background: "rgb(255, 255, 255);",
    transition: "box-shadow 0.2s, border 0.2s",
    m: 0,
  },
  StyledCardActive: {
    border: "2px solid #6366f1",
    boxShadow: "0 0 0 2px #6366f1",
  },
  CardHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
    mb: 1,
  },
  IconButton: {
    borderRadius: 8,
    padding: 6,
    marginRight: 8,
  },
  CardTitleContainer: {
    flex: 1,
  },
  CardDescription: {
    overflow: "hidden",
    maxHeight: "120px",
  },
};

export default DashboardItemCardStyles;
